import * as React from 'react';
import { Box, Breadcrumbs as MUIBreadcrumbs, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';
import './index.css';

type TBreadCrumbs = {
  id: number;
  path: string;
  name: string;
  keyId?: string;
  key?: string;
};

type TIdObj = {
  [key: string]: string | undefined;
};

interface IBreadcrumbs {
  breadCrumbsList: TBreadCrumbs[];
  callbackFnc?: any;
  idObj?: TIdObj;
}

const Breadcrumbs: React.FC<IBreadcrumbs> = ({ breadCrumbsList = [], callbackFnc, idObj }) => {
  const handleClick = (key: string) => {
    const path = idObj && idObj[key];
    if (callbackFnc) callbackFnc(path);
  };
  return (
    <Stack spacing={2} className="bread-crumbs--container">
      <MUIBreadcrumbs separator="›" aria-label="breadcrumb" className="bread-crumbs--box">
        {breadCrumbsList.map((list: TBreadCrumbs, i: number) => {
          return (
            <Box key={list.id} className="bread-crumbs--text-box">
              {list?.keyId ? (
                <Typography
                  onClick={() => list?.keyId && handleClick(list?.keyId)}
                  component={'span'}
                  className={
                    breadCrumbsList.length === i + 1
                      ? 'bread-crumbs--not-link'
                      : 'bread-crumbs--link'
                  }>
                  {list.name ? list.name : idObj && list?.key ? idObj[list?.key] : null}
                </Typography>
              ) : (
                <>
                  {' '}
                  {list.path ? (
                    <Link
                      to={list.path}
                      className={
                        breadCrumbsList.length === i + 1
                          ? 'bread-crumbs--not-link'
                          : 'bread-crumbs--link'
                      }>
                      {list.name ? list.name : idObj && list?.key ? idObj[list?.key] : null}
                    </Link>
                  ) : (
                    <Typography className="bread-crumbs--not-link">
                      {' '}
                      {list.name ? list.name : idObj && list?.key ? idObj[list?.key] : null}
                    </Typography>
                  )}
                </>
              )}
            </Box>
          );
        })}
        ,
      </MUIBreadcrumbs>
    </Stack>
  );
};

export default Breadcrumbs;
